<template>
    <b-container>
        <b-row>
            <b-col>
                <b-table
                    :fields="table.fields"
                    :items="table.items"
                    class="mb-3 mt-3"
                    striped
                    show-empty
                    responsive
                    empty-text="No Events to show"
                    outlined>
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                    <template #cell(note_text)="row">
                        <pre>{{row.item.text}}</pre>
                    </template>
                        <template #cell(created_at)="row">
                            <span :id="'tooltip-updated-notes' + row.index">{{$moment.utc(row.item.created_at).local().fromNow()}}</span>
                           <b-tooltip :target="'tooltip-updated-notes' + row.index" triggers="hover">
                                {{$moment.utc(row.item.created_at).local().format('llll')}}
                            </b-tooltip>
                        </template>
                </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col align="center">
                <b-button-group v-if="pages.length>1">
                    <b-button @click="searchNotes(currentPage-1)">Prev</b-button>
                    <b-button @click="searchNotes(currentPage+1)">Next</b-button>
                </b-button-group>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { AppointmentApi } from "@/app/appointments/appointmentApi";
import handleError from "@/errorHandler";

export default {
    name: "AppointmentEventList",
    props: {
        wardId: {
            type: String,
            required: false,
            default: null
        },
        appointmentId: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            noteText: null,
            nextPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            prevPage: {
                aux_id: null,
                pk_id: null,
                gsi_pk: null,
                gsi_sk: null
            },
            pages: [],
            currentPage: 0,
            lastPage: 0,
            table: {
                id: "appointment-note_list",
                fields: [
                    {
                        key: "text",
                        label: "Event"
                    },
                    {
                        key: "created_at",
                        label: "Added"
                    },
                    {
                        key: "added_by",
                        label: "Added By"
                    }
                ],
                items: [],
                isBusy: false,
                totalRows: 0,
                page: {
                    index: 1,
                    size: 5
                }

            }

        }
    },
    async mounted() {
        this.pages.push(this.nextPage);
        await this.searchNotes(0);
    },
    methods: {
        async searchNotes(page) {
            if(page < 0) {
                return;
            }
            if(page > this.pages.length - 1) {
                return;
            }
            const payload =  this.pages[page];
            this.table.isBusy = true;
            try {
                const { data } = await AppointmentApi.searchAppointmentEvents(this.wardId, this.appointmentId, payload);
                if (data.last_evaluated_key !== null) {
                    if(!this.existInPageList(data.last_evaluated_key, this.pages))
                        this.pages.push(data.last_evaluated_key);
                }
                this.table.items = data.result;
                this.table.isBusy = false;
                this.currentPage = page;
            } catch (e) {
                handleError(e, "Failed to fetch appointment events");
            }
        },
        existInPageList(obj, list) {
            if(list.length==0) return false;
            var i;
            for (i = 0; i < list.length; i++) {
                if(list[i].pk_id === obj.pk_id && list[i].aux_id === obj.aux_id) {
                    return true;
                }
            }
            return false;
        },
        async refresNoteList() {
            this.pages = [];
            this.currentPage = 0;
            this.lastPage = 0;
            this.pages.push(this.nextPage);
            await this.searchNotes(0);
        }
    }


}
</script>
<style lang="scss" scoped>
         pre {
            overflow-x: auto;
            white-space: pre-wrap;
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            word-wrap: break-word;
         }
</style>
